import { getLangCode } from '@/constants/language';
import { NextSeo, NextSeoProps } from 'next-seo';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';

export function useCanonicalUrl() {
	const router = useRouter();
	const path = router.asPath.split('?')[0].split('#')[0];
	const cleanPath = path === '/' ? '' : path.replace(/\/+$/, '');
	return `${process.env.NEXT_PUBLIC_BASE_URL}${cleanPath}`;
}

export function SeoHeader({
	description,
	title,
	images,
	...rest
}: NextSeoProps & {
	title: string;
	description?: string;
	images?: {
		url: string;
		secure_url: string;
		type: string;
		width: number;
		height: number;
	}[];
}) {
	const { t } = useTranslation(['core']);

	const SITE_NAME = 'Skip Pay';
	const canonicalUrl = useCanonicalUrl();
	const OG_IMAGE_ABSOLUTE_URL = `${process.env.NEXT_PUBLIC_BASE_URL}/images/og/${process.env.NEXT_PUBLIC_LANGUAGE}/image.png`;
	const OG_IMAGE_SQUARE_ABSOLUTE_URL = `${process.env.NEXT_PUBLIC_BASE_URL}/images/og/${process.env.NEXT_PUBLIC_LANGUAGE}/image_square.png`;

	const openGraph = {
		title: title,
		description,
		type: 'website',
		locale: getLangCode(process.env.NEXT_PUBLIC_LANGUAGE),
		url: canonicalUrl,
		site_name: SITE_NAME,
		images: images ?? [
			{
				url: OG_IMAGE_ABSOLUTE_URL,
				secure_url: OG_IMAGE_ABSOLUTE_URL,
				type: 'image/png',
				width: 1200,
				height: 630,
			},
			{
				url: OG_IMAGE_SQUARE_ABSOLUTE_URL,
				secure_url: OG_IMAGE_SQUARE_ABSOLUTE_URL,
				type: 'image/png',
				width: 300,
				height: 300,
			},
		],
	};

	const twitter = {
		cardType: 'summary_large_image',
		image: OG_IMAGE_ABSOLUTE_URL,
	};

	const facebook = {
		appId: process.env.NEXT_PUBLIC_FACEBOOK_APP_ID,
	};

	return (
		<NextSeo
			title={title}
			defaultTitle={t('defaultPageTitle', { siteName: SITE_NAME })}
			description={description}
			openGraph={openGraph}
			twitter={twitter}
			facebook={facebook}
			canonical={canonicalUrl}
			additionalMetaTags={[
				{
					content: '14e2beee77',
					name: 'verify-admitad',
				},
			]}
			{...rest}
		/>
	);
}
